<template>
  <div>
    <TextBlockWithHeader
        title="Обратная связь"
        text="По всем вопросам обращайтесь на почту <a href='mailto:171@corp.sputnik.ru'>171@corp.sputnik.ru</a>.
        <br />
        При обращении обязательно укажите адрес сайта и e-mail адрес администратора.
        "
    />
  </div>
</template>

<script>
    import {TextBlockWithHeader} from 'sputnik-ui/src/index';

    export default {
      name: 'FeedbackPage',
      components: {
        TextBlockWithHeader,
      },
    };
</script>

<style lang="scss">
  .cover-wrapper .cover {
    background-color: initial;
  }
  .text-block-with-header {
    text-align: center !important;
  }
</style>
